/*
 * @Description:
 * @Author: huyue
 * @Date: 2024-04-01 15:03:31
 * @LastEditors: huyue
 * @LastEditTime: 2024-08-13 14:42:56
 */
const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  912: {
    path: "/residentManage",
    name: "residentManage",
    meta: {
      title: "人员管理",
      authId: "912",
      parentId: "1",
      cache: false
    }
  },
  91201: {
    path: "/qualityControlList",
    name: "qualityControlList",
    meta: {
      title: "质检管理",
      authId: "91201",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/qualityControlList")
  },
  // 91202: {
  //   path: "/recepDetail",
  //   name: "recepDetail",
  //   meta: {
  //     title: "接待明细",
  //     authId: "91202",
  //     parentId: "91201",
  //     // sideHidden: true,
  //     cache: false,
  //     activePath: "/qualityControlList"
  //   },

  //   auth: [
  //     {
  //       authId: "9120201",
  //       parentId: "91202",
  //       label: "质检详情",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleQuality"
  //     }
  //   ],
  //   component: _import("residentManage/recepDetail")
  // },
  91203: {
    path: "/wordCard",
    name: "wordCard",
    meta: {
      title: "工牌管理",
      authId: "91203",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9120301",
        parentId: "91203",
        label: "数据同步",
        category: "Button",
        type: "primary",
        handle: "handleUpdate"
      }
    ],
    component: _import("residentManage/workCard")
  },
  91204: {
    path: "/inspectionPoint",
    name: "inspectionPoint",
    meta: {
      title: "质检点管理",
      authId: "91204",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/inspectionPoint")
  },
  91205: {
    path: "/inStoreManage",
    name: "inStoreManage",
    meta: {
      title: "驻店管理",
      authId: "91205",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9120501",
        parentId: "91205",
        label: "查看标签",
        handle: "handleViewLabel"
      },
      {
        authId: "9120502",
        parentId: "91205",
        label: "设备登录历史",
        category: "Button",
        type: "default",
        handle: "handleLoginHistory"
      },
      {
        authId: "9120503",
        parentId: "91205",
        label: "导出人员",
        category: "Button",
        type: "default",
        handle: "handleExportPerson"
      },
      {
        authId: "9120504",
        parentId: "91205",
        label: "导出标签",
        category: "Button",
        type: "default",
        handle: "handleExportLabel"
      },
      {
        authId: "9120505",
        parentId: "91205",
        label: "编辑员工",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "912050501",
            name: "编辑员工",
            parentId: "9120505"
          }
        ]
      },
      {
        authId: "9120506",
        parentId: "91205",
        label: "创建员工",
        category: "Button",
        type: "primary",
        handle: "handleCreateStaff"
      },
      {
        authId: "9120507",
        parentId: "91205",
        label: "导出员工业绩",
        category: "Button",
        type: "default",
        handle: "handleExportPerformance"
      },
      {
        authId: "9120508",
        parentId: "91205",
        label: "历史业绩",
        handle: "handleHistoryPerformance",
        addRoutePath: [
          {
            authId: "912050501",
            name: "历史业绩",
            parentId: "9120505"
          }
        ]
      },
      {
        authId: "9120509",
        parentId: "91205",
        label: "修订工资",
        handle: "handleEditSalary"
      },
      {
        authId: "9120510",
        parentId: "91205",
        label: "提成构成",
        handle: "handleSalaryDetail"
      }
    ],
    component: _import("residentManage/inStoreManage/inStoreControlList")
  },
  912050501: {
    path: "/staffInfo",
    name: "staffInfo",
    meta: {
      title: "员工信息",
      authId: "912050501",
      parentId: "9120505",
      cache: false,
      activePath: "/inStoreManage"
    },
    component: _import("residentManage/inStoreManage/staffInfo")
  },
  // 91206: {
  //   path: "/staffManage",
  //   name: "staffManage",
  //   meta: {
  //     title: "驻店工资绩效",
  //     authId: "91206",
  //     parentId: "912",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9120601",
  //       parentId: "91206",
  //       label: "导出工资绩效",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9120602",
  //       parentId: "91206",
  //       label: "导入员工",
  //       category: "Button",
  //       handle: "handleImport"
  //     },
  //     {
  //       authId: "9120603",
  //       parentId: "91206",
  //       label: "绩效配置",
  //       handle: "handlePerformance",
  //       addRoutePath: [
  //         {
  //           authId: "912060301",
  //           name: "绩效配置",
  //           parentId: "91206"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9120604",
  //       parentId: "91206",
  //       label: "导师配置",
  //       handle: "handleMentor",
  //       addRoutePath: [
  //         {
  //           authId: "912060401",
  //           name: "导师配置",
  //           parentId: "91206"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9120605",
  //       parentId: "91206",
  //       label: "启用工资绩效",
  //       handle: "handleEnableOrDisable",
  //       ruleObj: {
  //         attr: "performanceFlag",
  //         rule: {
  //           N: "启用工资绩效",
  //           Y: "禁用工资绩效"
  //         }
  //       }
  //     },
  //     {
  //       authId: "9120606",
  //       parentId: "91206",
  //       label: "业绩详情",
  //       handle: "handleDetail"
  //     }
  //   ],
  //   component: _import("systemConfig/businessSchoolManage/index")
  // },
  91208: {
    path: "/exercise",
    name: "exercise",
    meta: {
      title: "AI对练",
      authId: "91208",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/exercise/exerciseTab"),
    auth: [
      {
        authId: "9120801",
        parentId: "91208",
        label: "新建任务",
        category: "Button",
        type: "primary",
        handle: "handleToAdd",
        addRoutePath: [
          {
            authId: "912080403",
            name: "新建任务",
            parentId: "91208"
          }
        ]
      },
      {
        authId: "9120802",
        parentId: "91208",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      },
      {
        authId: "9120803",
        parentId: "91208",
        label: "查看",
        handle: "handleToView",
        addRoutePath: [
          {
            authId: "912080402",
            name: "查看",
            parentId: "91208"
          }
        ]
      },
      {
        authId: "9120804",
        parentId: "91208",
        label: "明细",
        handle: "handleToDetail",
        addRoutePath: [
          {
            authId: "912080401",
            name: "明细",
            parentId: "91208"
          }
        ]
      },
      {
        authId: "9120805",
        // parentId: "91208",
        // label: "明细",
        // handle: "handleToDetail",
        // addRoutePath: [
        //   {
        //     authId: "912080401",
        //     name: "明细",
        //     parentId: "91208"
        //   }
        // ]
        parentId: "91208",
        label: "结束",
        handle: "btnClickEnd",
        ruleObj: {
          attr: "taskState",
          rule: {
            1: "结束",
            2: "结束"
          },
          disabledStatusList: [2]
        }
      }
    ]
  },
  912080401: {
    path: "/exerciseDetail",
    name: "exerciseDetail",
    meta: {
      title: "明细",
      authId: "912080401",
      parentId: "91208",
      sideHidden: true,
      activePath: "/exerciseDetail"
    },
    component: _import("residentManage/exercise/detail")
  },
  912080402: {
    path: "/exerciseView",
    name: "exerciseView",
    meta: {
      title: "查看",
      authId: "912080402",
      parentId: "91208",
      sideHidden: true,
      activePath: "/exerciseView"
    },
    component: _import("residentManage/exercise/view")
  },
  912080403: {
    path: "/exerciseAdd",
    name: "exerciseAdd",
    meta: {
      title: "新建任务",
      authId: "912080403",
      parentId: "91208",
      sideHidden: true,
      activePath: "/exerciseAdd"
    },
    component: _import("residentManage/exercise/add")
  },
  // 912060301: {
  //   path: "/performanceConfig",
  //   name: "performanceConfig",
  //   meta: {
  //     title: "绩效配置",
  //     authId: "912060301",
  //     parentId: "91206",
  //     sideHidden: true,
  //     activePath: "/staffManage"
  //   },
  //   component: _import("systemConfig/businessSchoolManage/performanceConfig")
  // },
  // 912060401: {
  //   path: "/mentorConfig",
  //   name: "mentorConfig",
  //   meta: {
  //     title: "导师配置",
  //     authId: "912060401",
  //     parentId: "91206",
  //     sideHidden: true,
  //     activePath: "/staffManage"
  //   },
  //   component: _import("systemConfig/businessSchoolManage/mentorConfig")
  // },
  91207: {
    path: "/inStoreGoalsConfig",
    name: "inStoreGoalsConfig",
    meta: {
      title: "驻店目标配置",
      authId: "91207",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9120701",
        parentId: "91207",
        label: "新增",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "912070101",
            name: "新增",
            parentId: "91207"
          }
        ]
      },
      {
        authId: "9120702",
        parentId: "91207",
        label: "查看",
        handle: "handleStoreView",
        addRoutePath: [
          {
            authId: "912070201",
            name: "查看",
            parentId: "91207"
          }
        ]
      },
      {
        authId: "9120703",
        parentId: "91207",
        label: "编辑",
        handle: "handleStoreEdit",
        addRoutePath: [
          {
            authId: "912070101",
            name: "编辑",
            parentId: "91207"
          }
        ]
      },
      {
        authId: "9120704",
        parentId: "91207",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9120705",
        parentId: "91207",
        label: "查看",
        handle: "handleStaffView",
        addRoutePath: [
          {
            authId: "912070501",
            name: "查看任务",
            parentId: "91207"
          }
        ]
      }
    ],
    component: _import("systemConfig/inStoreGoalsConfig/index")
  },
  912070101: {
    path: "/addInStoreConfig",
    name: "addInStoreConfig",
    meta: {
      title: "新增",
      authId: "912070101",
      parentId: "91207",
      sideHidden: true,
      activePath: "/inStoreGoalsConfig"
    },
    component: _import("systemConfig/inStoreGoalsConfig/addInStoreConfig")
  },
  // 查看店面目标配置
  912070201: {
    path: "/inStoreConfigView",
    name: "inStoreConfigView",
    meta: {
      title: "查看",
      authId: "912070201",
      parentId: "91207",
      sideHidden: true,
      activePath: "/inStoreGoalsConfig"
    },
    component: _import("systemConfig/inStoreGoalsConfig/addInStoreConfig")
  },
  // 查看驻店员工任务
  912070501: {
    path: "/employeeTasksView",
    name: "employeeTasksView",
    meta: {
      title: "查看任务",
      authId: "912070501",
      parentId: "91207",
      sideHidden: true,
      activePath: "/inStoreGoalsConfig"
    },
    component: _import("systemConfig/inStoreGoalsConfig/employeeTasksView")
  },
  91209: {
    path: "/staffExamine",
    name: "staffExamine",
    meta: {
      title: "员工审核",
      authId: "91209",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9120901",
        parentId: "91209",
        label: "审核",
        handle: "handleExamine"
      },
      {
        authId: "9120902",
        parentId: "91209",
        label: "驳回",
        handle: "handleReject"
      }
    ],
    component: _import("residentManage/staffExamineList")
  },
  91210: {
    path: "/loginLogList",
    name: "loginLogList",
    meta: {
      title: "登录日志",
      authId: "91210",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9121001",
        parentId: "91210",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("residentManage/loginLogList")
  },
  91211: {
    path: "/tabletManagement",
    name: "tabletManagement",
    meta: {
      title: "平板管理",
      authId: "91211",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9121101",
        parentId: "91211",
        label: "新增信息",
        category: "Button",
        type: "primary",
        handle: "handleToAdd"
      },
      {
        authId: "9121102",
        parentId: "91211",
        label: "数据导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9121103",
        parentId: "91211",
        label: "编辑",
        handle: "handleToAdd"
      }
    ],
    component: _import("residentManage/tabletManagement")
  },
  91212: {
    path: "/salaryPerformance",
    name: "salaryPerformance",
    meta: {
      title: "驻店工资绩效",
      authId: "91212",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9121201",
        parentId: "91212",
        label: "新增绩效方案",
        category: "Button",
        type: "primary",
        handle: "handleToAdd",
        addRoutePath: [
          {
            authId: "912120101",
            name: "新增绩效方案",
            parentId: "91212"
          }
        ]
      },
      {
        authId: "9121202",
        parentId: "91212",
        label: "编辑",
        handle: "handleToEdit",
        addRoutePath: [
          {
            authId: "912120101",
            name: "编辑",
            parentId: "91212"
          }
        ]
      },
      {
        authId: "9121203",
        parentId: "91212",
        label: "删除",
        handle: "handleDelete"
      },
      {
        authId: "9121204",
        parentId: "91212",
        label: "启用",
        handle: "handleEnableOrDisable",
        ruleObj: {
          attr: "minPerformConfigStatus",
          rule: {
            null: '启用',
            2: "启用",
            1: "禁用"
          },
          disabledStatusList: [null]
        }
      },
      {
        authId: "9121205",
        parentId: "91212",
        label: "导出", // 门店工资绩效导出
        category: "Button",
        type: "default",
        handle: "handleExport"
      },
      {
        authId: "9121206",
        parentId: "91212",
        label: "新增支出",
        category: "Button",
        type: "primary",
        handle: "handleAddExpenditure"
      },
      {
        authId: "9121207",
        parentId: "91212",
        label: "导出", // 激励池导出
        category: "Button",
        type: "default",
        handle: "handleExport"
      },
      {
        authId: "9121208",
        parentId: "91212",
        label: "修改备注",
        handle: "handleToNote"
      },
      {
        authId: "9121209",
        parentId: "91212",
        label: "明细",
        handle: "handleDetail"
      },
      {
        authId: "9121210",
        parentId: "91212",
        label: "导入绩效方案",
        category: "Button",
        type: "primary",
        handle: "handleImport"
      },
      {
        authId: "9121211",
        parentId: "91212",
        label: "复制绩效方案",
        category: "Button",
        type: "primary",
        handle: "handleCopyConfig"
      }
    ],
    component: _import("residentManage/salaryPerformance/index")
  },
  912120101: {
    path: "/performanceScheme",
    name: "performanceScheme",
    meta: {
      title: "新增绩效方案",
      authId: "912120101",
      parentId: "91212",
      sideHidden: true,
      activePath: "/salaryPerformance"
    },
    component: _import("residentManage/salaryPerformance/performanceScheme")
  },
  91213: {
    path: "/inStorePoints",
    name: "inStorePoints",
    meta: {
      title: "驻店积分管理",
      authId: "91213",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9121301",
        parentId: "91213",
        label: "新增记录",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9121302",
        parentId: "91213",
        label: "批量导入",
        category: "Button",
        handle: "handleBatchImport"
      },
      {
        authId: "9121303",
        parentId: "91213",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      },
      {
        authId: "9121304",
        parentId: "91213",
        label: "编辑",
        handle: "handleEdit"
      },
      {
        authId: "9121305",
        parentId: "91213",
        label: "启用/停用",
        handle: "handleUpOrDown",
        ruleObj: {
          attr: "configStatus",
          rule: {
            1: "停用",
            0: "启用"
          }
        }
      }
    ],
    component: _import("residentManage/inStorePoints/indexControl")
  },
  91214: {
    path: "/growUpGrade",
    name: "growUpGrade",
    meta: {
      title: "成长等级管理",
      authId: "91214",
      parentId: "912",
      cache: false
    },
    auth: [
      {
        authId: "9121401",
        parentId: "91214",
        label: "导出",
        category: "Button",
        handle: "handleExport"
      },
      {
        authId: "9121402",
        parentId: "91214",
        label: "删除",
        handle: "handleDelete"
      },
      // {
      //   authId: "9121403",
      //   parentId: "91214",
      //   label: "导出",
      //   category: "Button",
      //   handle: "handleExport"
      // },
      {
        authId: "9121404",
        parentId: "91214",
        label: "编辑",
        handle: "handleEdit"
      },
      {
        authId: "9121405",
        parentId: "91214",
        label: "启用/停用",
        handle: "handleUpOrDown",
        ruleObj: {
          attr: "openState",
          rule: {
            true: "停用",
            false: "启用"
          }
        }
      },
      {
        authId: "9121406",
        parentId: "91214",
        label: "启用",
        handle: "handleUp"
      },
      {
        authId: "9121407",
        parentId: "91214",
        label: "禁用",
        handle: "handleDown"
      },
      {
        authId: "9121408",
        parentId: "91214",
        label: "查看",
        handle: "handleView"
      },
      {
        authId: "9121409",
        parentId: "91214",
        label: "删除",
        handle: "handleDelete"
      },
    ],
    component: _import("residentManage/growUpGrade/indexControl")
  },
  91215: {
    path: "/dailyPaperManagement",
    name: "dailyPaperManagement",
    meta: {
      title: "日报管理",
      authId: "91215",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/dailyPaperManagement/index")
  },
  91216: {
    path: "/measurement",
    name: "measurement",
    meta: {
      title: "收入测算配置",
      authId: "91216",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/measurement/index")
  },
  91217: {
    path: "/promotionAndDmotion",
    name: "promotionAndDmotion",
    meta: {
      title: "晋升/降级配置",
      authId: "91217",
      parentId: "912",
      cache: false
    },
    component: _import("residentManage/promotionAndDmotion/index")
  }
}
